var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgCalendarIcon = function SvgCalendarIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2532"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.22222 1.0459V3.22772M3.77778 1.0459V3.22772M1 5.40953H11M11 10.8641C11 7.88189 11 3.22772 11 3.22772C11 2.93839 10.8829 2.66091 10.6746 2.45633C10.4662 2.25174 10.1836 2.13681 9.88889 2.13681H2.11111C1.81643 2.13681 1.53381 2.25174 1.32544 2.45633C1.11706 2.66091 1 2.93839 1 3.22772V10.8641C1 11.1534 1.11706 11.4309 1.32544 11.6355C1.53381 11.8401 1.81643 11.955 2.11111 11.955H9.88889C10.7059 11.955 11 11.4459 11 10.8641Z",
    stroke: "#A498ED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendarIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar-icon.3563711c.svg";
export { ForwardRef as ReactComponent };